import React, { Component } from "react";
import { getTenantId, getAccessToken } from "egov-ui-kit/utils/localStorageUtils";

class FinFeModule extends Component {
  constructor(props) {
    console.log("props==", props);
    super(props);
    this.onFrameLoad = this.onFrameLoad.bind(this);
    this.resetIframe = this.resetIframe.bind(this);
    console.log("this.onFrameLoad=", this.onFrameLoad);
    console.log("this.resetIframe=", this.resetIframe);
  }
  onFrameLoad() {
    document.getElementById("erp_iframe").style.display = "block";
  }

  render() {
    console.log("menuUrl1==", menuUrl);
    let auth_token = getAccessToken(),
      locale = localStorage.getItem("locale"),
      menuUrl = this.props.location.pathname,
      loc = window.location,
      subdomainurl,
      domainurl,
      hrmsEnv,
      hostname = loc.hostname,
      winheight = window.innerHeight,
      erp_url,
      tenantId = getTenantId();
    console.log("menuUrl2s==", menuUrl);
    //Reading domain name from the request url
    domainurl = hostname.substring(hostname.indexOf(".") + 1);
    // Reading environment name (ex: dev, qa, uat, fin-uat etc) from the globalconfigs if exists else reading from the .env file
    hrmsEnv = this.globalConfigExists() ? window.globalConfigs.getConfig("FIN_ENV") : process.env.REACT_APP_FIN_ENV;
    // Preparing finance subdomain url using the above environment name and the domain url
    subdomainurl = !!hrmsEnv ? "-" + hrmsEnv + "." + domainurl : "." + domainurl;
   
    erp_url = loc.protocol + "//" + getTenantId().split(".")[1] + subdomainurl + menuUrl;
    console.log("erp_url=erp_url", erp_url);   
    erp_url = loc.protocol + "//" + "kmcdev.ddns.net" + menuUrl;
    console.log("subdomainurl=", subdomainurl); 
    console.log("erp_url=", erp_url);    
    console.log("domainurl", domainurl); 
    console.log("hrmsEnv", hrmsEnv); 
    return (
      <div>
        <iframe name="erp_iframe" id="erp_iframe" height="900"width="100%" />
        <form action={erp_url} id="erp_form" method="post" target="erp_iframe">
          <input readOnly hidden="true" name="auth_token" value={auth_token} />
          <input readOnly hidden="true" name="tenantId" value={tenantId} />
          <input readOnly hidden="true" name="locale" value={locale} />
          <input readOnly hidden="true" name="formPage" value="true" />
        </form>
      </div>
    );
  }
  componentDidMount() {
    window.addEventListener("message", this.onMessage, false);
    window.addEventListener("loacaleChangeEvent", this.resetIframe, false);
    document.getElementById("erp_iframe").addEventListener("load", this.onFrameLoad);
  }
  componentDidUpdate() {
    let isSecure = window.location.protocol === "https";
    let localeCookie = "locale=" + localStorage.getItem("locale") + ";path=/;domain=." + this.getSubdomain();
    console.log("localeCookie==", localeCookie);
    if (isSecure) {
      localeCookie += ";secure";
    }
    window.document.cookie = localeCookie;
    document.forms["erp_form"].submit();
  }
  onMessage = (event) => {
    if (event.data != "close") return;
    // document.getElementById('erp_iframe').style.display='none';
    this.props.history.push("/inbox");
  };
  resetIframe() {
    this.forceUpdate();
  }
  getSubdomain() {
    let hostname = window.location.hostname;
    console.log("hostname==", hostname);
    return hostname.substring(hostname.indexOf(".") + 1);
  }
  globalConfigExists() {
    return typeof window.globalConfigs !== "undefined" && typeof window.globalConfigs.getConfig === "function";
  }
}

export default FinFeModule;



// WEBPACK FOOTER //
// ./src/modules/citizen/FinFe/index.js